<script lang='ts'>
    import {SelectSlider} from "@/Common";
    import { recoveryBounds } from "@/Common/constants";

    export let recovery: number
    export let disabled = false
    export let onInput: () => void = () => {}

</script>

<div class="grid items-center">
    <SelectSlider class="col-span-2" {...recoveryBounds} {disabled}
        bind:value={recovery}
        on:input={onInput}
    />
    <span class="row-start-2 text-sm text-slate-400 self-start justify-self-start ml-1">Less</span>
    <span class="text-sm text-slate-400 self-start justify-self-end mr-1">More</span>
</div>